import { useCurrentDate } from "@sellar-io/components";
import { SupplierGetResponseType } from "@sellar-io/api-v2/types";
import {
  findLatestPreOrderAvailableFromDate,
  getNextStartDate,
} from "@sellar-io/common";
import dayjs from "dayjs";
import { DeliveryOrderItemType } from "./CourierDeliveryOptionsCard";
import { DeliveryOptionsCardCompact } from "./DeliveryOptionsCardCompact";

export const CollectionOptionsCard = ({
  supplier,
  orderItems,
}: {
  supplier: SupplierGetResponseType;
  orderItems?: DeliveryOrderItemType;
}) => {
  const currentDate = useCurrentDate();
  const latestAvailablePreOrderFromDate = findLatestPreOrderAvailableFromDate(
    orderItems?.map((item) => ({
      availableFrom: item.Product.availableFrom,
    })) ?? [],
  );
  const outOfOfficeReturnDate = supplier.SupplierOutOfOffice?.outOfOffice
    ? supplier.SupplierOutOfOffice.returnDate
    : null;

  const collectionDate = getNextStartDate({
    latestAvailablePreOrderFromDate,
    outOfOfficeReturnDate,
    courierDeliveryScheduleStartDate: null,
    currentDate,
  });

  const collectionDateText = collectionDate
    ? dayjs(collectionDate).format("ddd D MMM")
    : "Today";
  return (
    <DeliveryOptionsCardCompact
      supplierId={supplier.id}
      description={
        <div className={"flex flex-col"}>
          <p>
            Get it <strong>{collectionDateText}</strong>
          </p>
        </div>
      }
      fulfillmentType={undefined}
      title={
        <p>
          Collection from <strong>{supplier.Business.name}</strong>
        </p>
      }
    />
  );
};
